import { modelJson, weightBundles } from "../model_imports/mobilenet_v2_mid.js";
export var MobileNetV2MidModel = {
    name: "MobileNetV2Mid",
    numOfWeightBundles: 2,
    options: { type: "graph" },
    modelJson: modelJson,
    weightBundles: weightBundles,
};
//# sourceMappingURL=mobilenet_v2_mid.js.map